export default __webpack_public_path__ + "static/media/p1_xPlayzScreen2.ce100f47.png";